export const getPagesData = async () => {
  try {
    const response = await fetch('https://wp.bala.bokeylibrary.kz/wp-content/themes/main/data/get_data.php?file=page');
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error pages', error);
    return [];
  }
};
